import { Auth } from 'aws-amplify';

/**
 * A mocked version of an aws session.
 */
class MockSession {
  refreshToken = {
    token: 'iama.mockrefresh.token',
  }

  getIdToken() {
    return(
      {
        jwtToken: 'iama.mockid.token',
        payload: {
          email: 'sometest@email.com',
          // If cfs federated:
          //"cognito:groups": "eu-west-2_87ztWeh5V_Cirencester-Friendly",
          identities: [
            {
              userId: 'sometestuserid'
            },
          ]
        }
      }
    )
  }

  getAccessToken() {
    return(
      {
        jwtToken: 'iama.mockaccess.token',
      }
    )
  }
}

/**
 * Lib used to interact with Auth through an abstraction which allows for easy
 * mocking.
 */
export default class SessionLib {
  /**
   * Returns whether we need to mock.
   */
  static needsMock() {
    return(process.env.STORYBOOK || process.env.NODE_ENV === 'test');
  }

  /**
   * Returns the result from Auth.currentSession unless mocking.
   * Returns a promise that resolves to a mocked session after 1s otherwise.
   */
  static currentSession() {
    if (!this.needsMock()) {
      return(Auth.currentSession());
    }
    console.log('Using mock session.');
    return(
      new Promise(
        (resolve, reject) => {
          setTimeout(
            () => {
              resolve(new MockSession());
            },
            1000
          );
        }
      )
    );
  }
}
